import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { graphql } from 'src/generated';
import {
  QueryTableRowsInput,
  SortDirection,
  TableSortInput,
} from 'src/generated/graphql.js';
import type { Filter } from '../BoardFilter/types/filter.js';

export const TABLE_ROWS_QUERY = graphql(`
  query TableRows($input: QueryTableRowsInput!) {
    tableRows(input: $input) {
      _id
      ...tableRow
    }
  }
`);

export const useTableRowsQuery = ({
  boardId,
  tableId,
  filter,
  groupBy,
  sortBy,
}: {
  boardId: string;
  tableId: string;
  filter: Filter;
  groupBy: string[];
  sortBy: { column: string; direction: string }[];
}) => {
  const input = useMemo(() => {
    const input: QueryTableRowsInput = {
      boardId,
      tableId,
    };

    if (filter?.conditions.length >= 1) {
      input.filter = filter;
    }

    if (groupBy?.length >= 1) {
      input.groupBy = groupBy[0];
    }

    if (sortBy?.length >= 1) {
      input.sortBy = sortBy.map<TableSortInput>(
        ({ column, direction: dir }) => ({ column, dir: dir as SortDirection }),
      );
    }

    return input;
  }, [boardId, tableId, filter, groupBy, sortBy]);

  const { data, loading, refetch } = useQuery(TABLE_ROWS_QUERY, {
    nextFetchPolicy: 'cache-and-network',
    fetchPolicy: 'cache-and-network',
    variables: { input },
  });

  return {
    refetchRows: refetch,
    tableRows: data?.tableRows,
    isTableRowsLoading: loading,
  };
};
